import { __awaiter, __generator } from "tslib";
import { fetchConfig } from '@office-start/config-query-wrapper-service';
import { sharedContextConfigOptions } from '../options/sharedContextConfigOptions';
export function fetchSharedContext() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchConfig(sharedContextConfigOptions)];
        });
    });
}
//# sourceMappingURL=fetchSharedContext.js.map